// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","card":"PurchasingPower_card__9SDu-","heading":"PurchasingPower_heading__s-M5b","grid":"PurchasingPower_grid__HxHx0"};